import { daysBetween } from './daysBetween';

export const daysBetweenNowAndDate = (expirationDate: Date) => {
  return daysBetween(new Date(), expirationDate);
};
